export const FESTIVAL_SELECTION_PATH = '/festival-auswahl'
export const LOGIN_PATH = '/login'
export const APP_BASE_PATH = '/app'
